import React from 'react';
import {Container,Row,Col,Button,Modal, Table, Badge} from 'react-bootstrap';
import API from '../API.js'
import Nav from '../Components/Nav'
import ModalAlert from '../Components/ModalAlert'
import FeatureFlags from '../Config'

export default class NewMessage extends React.Component {

    constructor(props){
      super(props)
  
      this.state = { 
        showConfirmation:false,
        message:"",
        showMessage:false,
        messageText: "",
        messageTitle: "",

        // Groups
        selectedGroups:[],
        showManageRecipientsModal:false,

        // Attachments
        selectedAttachments:[],
      }
    }
  
    didChangeInput(event){
      this.setState({message:event.target.value})
    }
  
    didPressNext(){
      this.setState({showConfirmation:true})
    }
  
    didPressCancel(){
      this.setState({showConfirmation:false})
    }
  
    didPressConfirm(){
      this.setState({showConfirmation:false})
  
      const groupIds = this.state.selectedGroups.map(group=>{return group.groupId})

      API.sendMessage(groupIds, this.state.message).then(result=>{
        this.setState({
          showMessage:true,
          messageText: "Your Message Has been sent.",
          messageTitle: "Message Sent"
        })
        // TODO: consider clearing the text box
        // TODO: Navigate User Away from Page
      }, error=>{
        this.setState({
          showMessage:true,
          messageText: "An Unknown error has occured, please try again or contact admin.",
          messageTitle: "Error"
        })
      })
    }

    didPressOk(){
      this.setState({showMessage:false})
    }

    didPressAddRecipients(){
      this.setState({showManageRecipientsModal:true})
    }

    didPressRemoveGroup(removeGroup){
      var selectedGroups = this.state.selectedGroups.filter(group=>{
        return group.groupId !== removeGroup.groupId
      })
      this.setState({selectedGroups:selectedGroups})
    }

    // RecipientsModal
    didPressDoneManageRecipients(){
      this.setState({showManageRecipientsModal:false})
    }

    didChangeSelectedGroups(selectedGroups){
      this.setState({selectedGroups:selectedGroups})
    }

    // Attachments
    didPressRemoveAttachment(attachment){
      // TODO: 
    }

    didPressAddAttachments = () => {

    }

    render(){
      const GroupsList = props=>{
        if(props.groups.length === 0){
          return ( 
            <tr>
              <td>No Recipients</td>
            </tr>
          )
        } else {
          return props.groups.map(group=>{
              return (
                <tr key={group.groupId}>
                  <td>{group.name}</td>
                  <td><Button variant="danger" onClick={this.didPressRemoveGroup.bind(this, group)}>Remove</Button></td>
                </tr>
              )
            }) 
        }
      }

      const AttachmentsList = props=>{
        if(props.attachments.length === 0){
          return ( 
            <tr>
              <td>No Attachments</td>
            </tr>
          )
        } else {
          return props.attachments.map((attachment,idx)=>{
              return (
                <tr key={idx}>
                  <td>{attachment.name}</td>
                  <td><Button variant="danger" onClick={this.didPressRemoveAttachment.bind(this, attachment)}>Remove</Button></td>
                </tr>
              )
            }) 
        }
      }

      return (
        <Container fluid>
          <Row>
            <Nav />
            <Col style={{marginBottom:50}}>
              <h3 style={{paddingTop:10, paddingBottom:10}}>New Message</h3>

              <strong>To:</strong>
              <Table bordered>
                <tbody>
                  <GroupsList groups={this.state.selectedGroups}/>
                </tbody>
              </Table>
              <Button onClick={this.didPressAddRecipients.bind(this)}>Add Recipients</Button> 
              <hr/>

              <p><strong>Character Count:</strong> {this.state.message.length}</p>
              <Row>
                <textarea style={{height:300, width:"100%", marginLeft:20, marginRight:20}} onInput={this.didChangeInput.bind(this)}></textarea>
              </Row>
              <hr/>
              { FeatureFlags.AttachmentSupport ? (
                <>
                  <strong>Attachments:</strong>
                  <Table bordered>
                    <tbody>
                      <AttachmentsList attachments={this.state.selectedAttachments}/>
                    </tbody>
                  </Table>
                  <input style={{display:"none"}} type="file" id="customFile" onChange={this.didPressAddAttachments}/>

                  <Button htmlType="file" onClick={this.didPressAddAttachments}>Add Attachments</Button>
                  <hr/>
                </>
              ) : (null) }
              
              <p><strong>Note:</strong> You will be able to review the message before you send it.</p>
              <Button variant="primary" onClick={this.didPressNext.bind(this)} disabled={this.state.message.length === 0 || this.state.selectedGroups.length === 0  }>Next</Button>
            </Col>
          </Row>
  
          <Modal show={this.state.showConfirmation} onHide={this.didPressCancel.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Send</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to send this message?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.didPressCancel.bind(this)}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.didPressConfirm.bind(this)}>
                Send
              </Button>
            </Modal.Footer>
          </Modal>

          <ModalAlert 
              show={this.state.showMessage} 
              messageTitle={this.state.messageTitle} 
              messageText={this.state.messageText}   
              didPressOk={this.didPressOk.bind(this)}
          />

          <ManageRecipientsModal 
            show={this.state.showManageRecipientsModal}
            selectedGroups={this.state.selectedGroups}
            didChangeSelectedGroups={this.didChangeSelectedGroups.bind(this)}
            didPressDone={this.didPressDoneManageRecipients.bind(this)}
            />
          
        </Container>
      )
    }
  }

class ManageRecipientsModal extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      // Groups
      groups:[]
    }
  }

  componentDidMount(){
    this.fetchGroups()
  }

  fetchGroups(){
    API.groups().then(groups=>{
        this.setState({groups:groups})
    }, error=>{
        // TODO: handle error
    })
  }

  didPressAddGroup(group){
    var selectedGroups = this.props.selectedGroups
    selectedGroups.push(group)
    this.props.didChangeSelectedGroups(selectedGroups)
  }

  render(){

    const GroupsList = (props) => {
      if(this.state.groups.length === 0){
        return (
          <tr key={0}>
              <td style={{height:70}}>
                  No Groups Found
              </td>
          </tr>
        )
      } else {
        return this.state.groups.map(group=>{
            return (
              <tr key={group.groupId}>
                    <td style={{height:70}}>
                        {group.name} 
                    </td>
                    <td>
                      {
                        this.props.selectedGroups.includes(group) ? (<Badge pill variant="secondary">Added</Badge>) : (<Button onClick={this.didPressAddGroup.bind(this,group)}>Add</Button>)
                      }
                    </td>
                </tr>
            )
        })
      }
    }

    return (
      <Modal show={this.props.show} onHide={this.props.didPressDone}>
        <Modal.Header>
            <Modal.Title>Add Recipients</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <br />
          <Table bordered >
            <tbody>
              <GroupsList />
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={this.props.didPressDone}>Done</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}